// extracted by mini-css-extract-plugin
export default {"base":"vp__ve03","card":"vp__FktS","description":"vp_U6CDn","icon":"vp_G3EVC","name":"vp_u7f07"};